<template>
    <div class="tab_content">
        <div class="search_box clearfix">
            <div class="search_time search_inputBox">
               <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
               ~
               <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer>
            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="search">查询</el-button>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="report.order.customer" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="text-center">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber" v-if="statistics.out_cube">出库方数：{{statistics.out_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_cube">销售方数: {{statistics.sales_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_amount">销售金额：¥{{statistics.sales_amount }}</div>
            <div class="totalNumber" v-if="statistics.purchase_amount">采购金额：¥{{statistics.purchase_amount }}</div>
            <div class="totalNumber" v-if="statistics.cost_amount">成本费用：¥{{statistics.cost_amount }}</div>
            <div class="totalNumber" v-if="statistics.reduce_amount">优惠金额: ¥{{statistics.reduce_amount }}</div>
            <div class="totalNumber" v-if="statistics.business_expense">营业支出: ¥{{statistics.business_expense }}</div>
            <div class="totalNumber" v-if="statistics.sales_margin">销售利润: ¥{{statistics.sales_margin }}</div>
        </div>
        <filter-fields :tableData="filter" scene="report.order.customer" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
    </div>
</template>
<style scoped lang="scss">
    .totalNumber{margin-right: 10px;}
    .totalName{margin-right: 10px;}
    // .container{ }
</style>
<script>
import tabletem from '../../../components/table.vue'
import pagination from '../../../components/pagination.vue'
import selectDownCustomer from '../../../components/selectDownCustomer.vue'
    export default {
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        data(){
            return{
                tableLoading:false,
                start_time: "",
                end_time: "",
                customerList : [],
                params : {
                    page : 1,
                    per_page : 50,
                    search : {
                        start_time : "",
                        end_time : "",
                        customer_id : ""
                    }
                },
                last_page : 1,
                current_page : 1,
                total:0,
                statistics :  {
                    total_cube :  "",
                    total_amount :  "",
                    total_count :  "",
                    already_amount :  "",
                    outstanding_amount :  ""
                },

                list:[],
                tableCol:[
                    {colName:"客户名称",colKey:"customer_name",colWidth:140,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"件数",colKey:"count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"方数",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本费用",colKey:"cost_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"优惠金额",colKey:"reduce_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"营业支出",colKey:"business_expense",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售利润",colKey:"sales_margin",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"利润率",colKey:"margin_rate",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                filterDialogVisible:false,
                filter:"",
                fields:"",
            }
        },
        mounted(){
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = new Date();
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.summarizing.sales.customer","销售汇总(客户)",this.params)
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.$postColumnList("/erp/report.order.customer",this.params,response=>{
                        let list = response.data.data.list
                        list.forEach((item) => {
                            // item.sales_time =  window.moment( Number(item.sales_time) * 1000 ).format("YYYY-MM-DD")
                            item.sales_cube = Number(item.sales_cube).toFixed(4)
                            item.sales_amount = Number(item.sales_amount).toFixed(2)
                            item.already_amount = Number(item.already_amount).toFixed(2)
                            item.outstanding_amount = Number(item.outstanding_amount).toFixed(2)
                            item.reduce_amount = Number(item.reduce_amount).toFixed(2)
                        })
                        this.list = list;
                        this.filter = response.data.data.column;
                        this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                        })
                        this.total = response.data.data.total;
                        this.statistics = response.data.data.statistics;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        this.last_page = response.data.data.last_page;
                })
            },
            filterConfirm(){
                this.getList()
            },
            search(){
                this.params.search.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.search.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                if(this.params.page == 1){
                    this.tableColCopy = this.$deepClone(this.tableCol);
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                // this.start_time = this.$getCurrentMonthStartValueOf();
                // this.end_time = new Date();
                this.$refs['selectdowncustomer'].clearData();
                this.start_time = "";
                this.end_time = "";
                this.params.search = {
                    start_time : "",
                    end_time : "",
                    customer_id : ""
                }
                this.getList()
            },
            // 获取客户
            getCustomerList(visible){
                if(visible){
                    this.$getCustomerList(this.params.search.salesman_id).then(res=>{
                        this.customerList = res.data.data;
                    })
                }
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
